import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';

const actions = {
  async features({ commit }) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios('/settings');
    commit('SET_SETTINGS', result.data);
    commit('SET_SETTINGS_LOADING', false);
  },

  async update({ commit }, { features }) {
    commit('SET_SETTINGS_LOADING', true);
    await axios.put('/settings', { data: features });
    commit('SET_SETTINGS_LOADING', true);
  },

  async sla({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/sla', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async centralHO({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/central_ho/show');
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async wallet({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/wallet', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async holidays(_, params) {
    try {
      const result = await axios.get(`/settings/depot/${params.depot_id}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async holidaysUpdate(_, params) {
    try {
      const result = await axios.post('/settings/depot/holidays', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async approvals(_, { depotId, movement, eventType, deliveryType }) {
    try {
      _.commit('SET_SETTINGS_LOADING', true);
      const result = await axios.get(`/settings/approvals?depot_id=${depotId}&movement=${movement}&event_type=${eventType}&delivery_type=${deliveryType}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      _.commit('SET_SETTINGS_LOADING', false);
    }
  },
  async approvalsUpdate(_, params) {
    try {
      const result = await axios.put('/settings/approvals', params);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async deleteHoliday(_, params) {
    try {
      const result = await axios.delete(`/settings/depot/${params.depot_id}`, {
        data: params.holiday,
      });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async slaupdate(_, params) {
    const result = await axios.put('/settings/depot/sla', { data: params });
    return result;
  },

  async centralHOUpdate(_, params) {
    try {
      _.commit('SET_SETTINGS_LOADING', true);
      const id = params.id;
      delete params.id;
      const result = await axios.put(`/settings/central_ho/${id}`, {data: params});
      _.commit('SET_SETTINGS_LOADING', false);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async centralHOCreate(_, params) {
    _.commit('SET_SETTINGS_LOADING', true);
    const result = await axios.post('/settings/central_ho', { data: params });
    _.commit('SET_SETTINGS_LOADING', false);
    return result;
  },

  async centralHODelete(_, params = {}) {
    _.commit('SET_SETTINGS_LOADING', true);
    const result = await axios.delete(`/settings/central_ho/${params.id}`);
    _.commit('SET_SETTINGS_LOADING', false);
    return result;
  },

  async walletupdate(_, params) {
    const result = await axios.put('/settings/depot/wallet', { data: params });
    return result;
  },

  async materialHeaders({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/material_header', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async headersupdate(_, params) {
    const result = await axios.put('/settings/depot/material_header', { data: params });
    return result;
  },

  async notifications({ commit }) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/notification');
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async notificationupdate(_, params) {
    const result = await axios.put('/settings/notification', { data: params });
    return result;
  },

  async unit({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/unit', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async unitupdate(_, params) {
    const result = await axios.put('/settings/depot/unit', { data: params });
    return result;
  },

  async lrdepot({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/lr', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async lrdepotupdate(_, params) {
    const result = await axios.put('/settings/depot/lr', { data: params });
    return result;
  },

  async lrclient({ commit }) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/lr');
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async lrclientupdate(_, params) {
    const result = await axios.put('/settings/lr', { data: params });
    return result;
  },

  async bidSettings(_, params) {
    try {
      const result = await axios.get('/settings/depot/bid_slot_settings', { params });
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async bidSettingsUpdate(_, params) {
    try {
      const result = await axios.put('/settings/depot/bid_slot_settings', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async shortageDamage(_, params) {
    try {
      const result = await axios.get(`/settings/ShortageDamage?movement=${params.movement}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getPayAnomaly(_, params) {
    try {
      const result = await axios.get('/settings/pay_anomaly', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updatePayAnomaly(_, params) {
    try {
      const result = await axios.put('/settings/pay_anomaly', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async chat(_, params) {
    try {
      const result = await axios.get(`/settings/Chat?movement=${params.movement}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },


  async freightChargeThreshold(_, params) {
    try {
      const result = await axios.get('/settings/freight_charge_threshold');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async shortageDamageUpdate(_, params) {
    try {
      const result = await axios.put('/settings/ShortageDamage', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async chatUpdate(_, params) {
    try {
      const result = await axios.put('/settings/chat', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async freightChargeThresholdUpdate(_, params) {
    try {
      const result = await axios.put('/settings/freight_charge_threshold', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getOpenIndentsCharge(_, params) {
    try {
      const result = await axios.get('/settings/depot/openIndentsCharge', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateOpenIndentsCharge(_, params) {
    try {
      const result = await axios.put('/settings/depot/openIndentsCharge', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getBillDiscountConfig(_, params) {
    try {
      const result = await axios.get('/settings/billDiscount');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateBillDiscountConfig(_, params) {
    try {
      const result = await axios.put('/settings/billDiscount', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getIndentConfig({ commit }, params) {
    try {
      commit('SET_SETTINGS_LOADING', true);
      const result = await axios.get('/settings/depot/indent', { params });
      commit('SET_SETTINGS_LOADING', false);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async detention({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/detention', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result ? result.data : null;
  },

  async detentionUpdate(_, params) {
    const result = await axios.put('/settings/depot/detention', { data: params });
    return result;
  },


  async getDocumentConfig({ commit }, params) {
    commit('SET_SETTINGS_LOADING', true);
    const result = await axios.get('/settings/depot/document', { params });
    commit('SET_SETTINGS_LOADING', false);
    return result && result.data;
  },

  async getDocumentCodes({ commit }) {
    const result = await axios.get('/packing/documentkey');
    return result && result.data;
  },

  async documentConfigUpdate(_, params) {
    try {
      const result = await axios.put('/settings/depot/document', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  /* vehicle utilisation related apis */
  async getVehicles(_, query = null) {
    try {
      let result = {};
      if (query) {
        result = await tmsMdmAxiosInstance.get(`/vehicle_type?list=${query}`);
      } else {
        result = await tmsMdmAxiosInstance.get('/vehicle_type');
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async updateWalletConfig(_, params) {
    try {
      const result = await axios.put('/settings/client_configurations/wallet_config', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getStaticDiscountConfig(_, params) {
    try {
      const result = await axios.get('/settings/static_discounting');
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateStaticDiscountConfig(_, params) {
    try {
      const result = await axios.put('/settings/static_discounting', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getWalletConfig(_, params) {
    try {
      const result = await axios.get('/settings/client_configurations/wallet_config');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getUtilizationThreshold(_, payload) {
    try {
      const result = await axios.get(`/vehicle_utilization_threshold/${payload.vehicle_id}?movement=${payload.movement}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async setUtilizationThreshold(_, payload) {
    try {
      const data = {
        utilisation_check_category: payload.vehicleUtilisationBasedOn,
        weight_lower: payload.minimum_weight,
        weight_upper: payload.maximum_weight,
        volume_lower: payload.minimum_volume,
        volume_upper: payload.maximum_volume,
      };
      const url = `/vehicle_utilization_threshold/${payload.vehicle_type_id}?movement=${payload.movement}`;
      const result = await axios.put(url, { data });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async bulkUpdateUtilizationThreshold(_, payload) {
    try {
      const data = {
        vehicle_type_id: payload.vehicle_type_id,
        movement: payload.movement,
        utilisation_check_category: payload.vehicleUtilisationBasedOn,
        weight_lower: payload.minimum_weight,
        weight_upper: payload.maximum_weight,
        volume_lower: payload.minimum_volume,
        volume_upper: payload.maximum_volume,
      };
      const result = await axios.post('/vehicle_utilization_threshold', { data });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async setDefaultBillToParty(_, payload) {
    try {
      const data = {
        bill_to_party:payload.billToParty,
        movement:payload.movement,
      };
      const result = await axios.put('/settings/client_configurations/bill_to_party', data);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async updateFreightBillConfig(_, params) {
    try {
      const result = await axios.put('/settings/client_configurations/freight_bill_config', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async searchTransporter(_, params) {
    try {
      const result = await axios.get('/settings/transporter', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createInsuranceSlab(_, params) {
    try {
      const result = await axios.post('/settings/insurance-slab', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async listInsuranceSlabs(_, params) {
    try {
      const result = await axios.get('/settings/insurance-slabs');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async deleteInsuranceSlab(_, params) {
    try {
      const result = await axios.delete(`/settings/insurance-slab/${params.slab_id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getInsuranceSlab(_, params) {
    try {
      const result = await axios.get(`/settings/insurance-slab/${params.slab_id}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getFreightBillConfig(_, params) {
    try {
      const result = await axios.get('/settings/client_configurations/freight_bill_config');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateInsuranceSlab(_, params) {
    try {
      const result = await axios.put('/settings/insurance-slab', { data: params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getVehicleList(_, params) {
    try {
      const result = await axios.get('/settings/vehicle_type');
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getFixedDebitConfig(_, params) {
    try {
      const result = await axios.get('/settings/depot/fixed_debit', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateFixedDebitConfig(_, params) {
    try {
      const result = await axios.put('/settings/depot/fixed_debit', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getGatePassConfig(_, params) {
    try {
      const result = await axios.get('/settings/depot/gate_pass', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateGatePassConfig(_, params) {
    try {
      const result = await axios.put('/settings/depot/gate_pass', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getFreightBillPostingSettings(_, params) {
    try {
      const result = await axios.get('/settings/depot/freight_bill_posting', { params });
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateFreightBillPostingSettings(_, params) {
    try {
      const result = await axios.put('/settings/depot/freight_bill_posting', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateLorryReceiptConfig(_, params) {
    try {
      const result = await axios.put('/settings/client_configurations/update_lr_config', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getInvoiceCustomFields(_, params) {
    try {
      const result = await axios.get('/settings/invoiceCustomFields', { params });
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateInvoiceCustomFields(_, params) {
    try {
      const result = await axios.put('/settings/invoiceCustomFields', params);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getFapInvoiceSettings() {
    try {
      const result = await axios.get('/settings/client/fap_invoice_settings');
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateFapInvoiceSettings(_, params) {
    try {
      const result = await axios.put('/settings/client/fap_invoice_settings', params);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getLegalEntityList(_, params) {
    try {
      let url = 'legal_entity/search';
      if (params && params.legal_entity_code) {
        url = `${url}?legal_entity_code=${params.legal_entity_code}`;
      }
      const result = await tmsMdmAxiosInstance.get(url);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateLegalEntitySetting(_, params) {
    try {
      const result = await axios.put('/settings/legalEntity', params);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getDetentionClientConfig(_) {
    try {
      const result = await axios.get('/settings/client/detention');
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async updateDetentionClientConfig(_, params) {
    try {
      const result = await axios.put('/settings/client/detention', params);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async mastersApprovals(_, { eventType }) {
    try {
      _.commit('SET_SETTINGS_LOADING', true);
      const result = await axios.get(`/settings/master_approvals?event_type=${eventType}&isMasterApprovals=${true}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      _.commit('SET_SETTINGS_LOADING', false);
    }
  },
  async mastersApprovalsUpdate(_, params) {
    try {
      const result = await axios.put('/settings/master_approvals', params);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getMastersCustomFields(_, { eventType }) {
    try {
      _.commit('SET_SETTINGS_LOADING', true);
      const result = await axios.get(`/settings/custom_fields?type=${eventType}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      _.commit('SET_SETTINGS_LOADING', false);
    }
  },
  async mastersCustomFieldUpdate(_, params) {
    try {
      const payload = { data: { fields: params.fields } };
      const result = await axios.put(`/settings/custom_fields?type=${params.type}`, payload);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getReasonSettings(_, params) {
    try {
      let url = '/settings/depot/reason_settings?';
      if (params.depot_id) {
        url = `${url}depot_id=${params.depot_id}`;
      }
      if (params.movement) {
        url = `${url}&movement=${params.movement}`;
      }
      if (params.type) {
        url = `${url}&type=${params.type}`;
      }
      const result = await axios.get(url);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async updateReasonSettings(_, params) {
    try {
      const result = await axios.put('/settings/depot/reason_settings', params);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getInvoiceApprovalSettings(_) {
    try {
      const result = await axios.get('/settings/client/invoice_approval');
      return result;
    } catch (error) {
      return error;
    }
  },
  async updateInvoiceApprovalSettings(_, params) {
    try {
      const result = await axios.put('/settings/client/invoice_approval', { data: params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
